import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Prevent iOS/home-screen (PWA) from serving cached GET responses:
// append a timestamp so every read pulls fresh data from the server.
api.interceptors.request.use((config) => {
  if ((config.method || "get").toLowerCase() === "get") {
    config.params = { ...(config.params || {}), _t: Date.now() };
  }
  const ws = localStorage.getItem("lwp_ws");
  if (ws) config.headers["X-Workspace-Id"] = ws;
  return config;
});

export default api;
